

export const manageAuthorState = (state) => {
    return state.AUTHORS;
};